import { renderSlot as _renderSlot, vModelDynamic as _vModelDynamic, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3097730c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "native-input" }
const _hoisted_2 = ["type", "placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['fx-input', _ctx.focus && 'focus'])
  }, [
    _renderSlot(_ctx.$slots, "prepend", {}, undefined, true),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        onkeyup: "value=value.replace(/^(0+)|[^\\d]+/g,'')",
        type: _ctx.type,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
        style: _normalizeStyle({
          textAlign: _ctx.align
        }),
        placeholder: _ctx.placeholder,
        onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.focusHandler && _ctx.focusHandler(...args))),
        onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.blurHandler && _ctx.blurHandler(...args)))
      }, null, 44, _hoisted_2), [
        [_vModelDynamic, _ctx.inputValue]
      ])
    ]),
    _renderSlot(_ctx.$slots, "append", {}, undefined, true)
  ], 2))
}